"use strict";
var list = document.querySelector("ul");
var parseSalary = function(salaryStr) {
    return Number(salaryStr.replace(/[^0-9.-]+/g, ""));
};
function sortList(listElement) {
    var items = Array.from(listElement.children);
    items.sort(function(a, b) {
        var salaryA = parseSalary(a.dataset.salary);
        var salaryB = parseSalary(b.dataset.salary);
        return salaryB - salaryA;
    });
    items.forEach(function(li) {
        return listElement.append(li);
    });
}
function getEmployees(listElement) {
    var items = Array.from(listElement.children);
    return items.map(function(li) {
        return {
            name: li.textContent.trim(),
            position: li.dataset.position,
            salary: parseSalary(li.dataset.salary),
            age: Number(li.dataset.age)
        };
    });
}
sortList(list);
getEmployees(list);

//# sourceMappingURL=index.4350d3e7.js.map
